import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import styles from './section-heading.scss';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    readonly className?: string;
    readonly dataTestId?: string;
    readonly noPadding?: boolean;
  };

const COMPONENT_ID = 'modulor-section-heading';

export const SectionHeading: ForwardRefExoticComponent<Props> = forwardRef<HTMLDivElement, Props>(
  ({ children, className, noPadding, ...rest }, ref, dataTestId = COMPONENT_ID) => {
    const classes = classNames(className, styles.container, {
      [styles.noPadding]: noPadding,
    });
    return (
      <div
        data-testid={dataTestId}
        data-component-name={COMPONENT_ID}
        data-id={dataTestId}
        ref={ref}
        className={classes}
        {...rest}>
        {children}
      </div>
    );
  },
);

SectionHeading.displayName = 'SectionHeading';
